import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faq").then(({ data }) => setItems(data.items)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-head text-4xl sm:text-5xl font-black tracking-tighter mb-3">Frequently Asked Questions</h1>
      <p className="text-muted-foreground mb-8">Everything you need to know about singing on SINGVI KARAOKE.</p>
      <Accordion type="single" collapsible className="space-y-3">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`i${i}`} className="card-surface rounded-2xl px-5 border-0" data-testid={`faq-${i}`}>
            <AccordionTrigger className="text-left font-head font-semibold hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
